import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//actions
import { postUpdated, updateFilterSelected } from '../actions';

class TypeField extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.onChange = this.onChange.bind(this);
  }

  onChange = e => {
    let selected = this.selectRef.current.value;
    //update filters in redux
    this.props.updateFilterSelected('type', selected);
    this.props.postUpdated('asc', selected, this.props.data, 'type');
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.filters.clear_filter.active) {
      this.clearField();
    }
  }

  clearField() {
    this.selectRef.current.value = '';
  }

  render() {
    return (
      <select className="form-control" ref={this.selectRef} onChange={this.onChange}>
        <option value="">Type</option>
        <option value="Article">Article</option>
        <option value="Book">Book</option>
        <option value="Case Study">Case Study</option>
        <option value="IP Alert">IP Alert</option>
        <option value="Speech">Speech</option>
        <option value="PTAB Highlights">PTAB Highlights</option>
      </select>
    );
  }
}

TypeField.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = dispatch => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value))
  };
};

const mapStateToProps = state => {
  return {
    type: state.postData.type,
    filteredData: state.postData.filteredData,
    data: state.postData.data,
    filters: state.filters
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TypeField);
